import { DSScaledColors } from 'styles';
import { AvatarProps } from './avatar.types';

const COLORS = [
  'primary',
  'gray',
  'orange',
  'red',
  'green',
  'purple',
] as (keyof DSScaledColors)[];

/**
 * Детерминированно возвращает цвет аватарки на основе переданной строки.
 *
 * Суммирует Unicode-коды символов строки и берёт остаток от деления
 * на количество доступных цветов. Одна и та же строка всегда даёт один и тот же цвет.
 *
 * @param str - Уникальный идентификатор пользователя (имя, email, id и т.д.)
 * @returns Цвет из списка доступных оттенков аватарки
 *
 * @example
 * getColorFromString('Никита') // → 'gray'
 */
export const getColorFromString = (
  str: string
): NonNullable<AvatarProps['color']> => {
  const hash = str.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return COLORS[hash % COLORS.length];
};
